import { render, staticRenderFns } from "./MensajesPantalla.vue?vue&type=template&id=4dce4be4&"
import script from "./MensajesPantalla.vue?vue&type=script&lang=ts&"
export * from "./MensajesPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4dce4be4', component.options)
    } else {
      api.reload('4dce4be4', component.options)
    }
    module.hot.accept("./MensajesPantalla.vue?vue&type=template&id=4dce4be4&", function () {
      api.rerender('4dce4be4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/CopilotoVirtual/Mensaje/MensajesPantalla.vue"
export default component.exports